import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";
import PreviewModal from "./PreviewModal";
import PaymentModal from "./PaymentModal";
import { Link } from "react-router-dom";

export default function AddInvoices({ show, onHide }) {
  const [preview, setPreview] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [childModalOpen, setChildModalOpen] = useState(false);
  const [items, setItems] = useState([
    { description: "", qty: "", discount: "", rate: "" },
  ]);

  const handleChildOpen = () => setChildModalOpen(true);
  const handleChildClose = () => setChildModalOpen(false);

  const openPreview = () => {
    handleChildOpen();
    setPreview(true);
    setPaymentModal(false);
  };

  const closePreview = () => {
    setPreview(false);
    handleChildClose();
  };

  const openPaymentModal = () => {
    handleChildOpen();
    setPaymentModal(true);
    setPreview(false);
  };

  const closePaymentModal = () => {
    setPaymentModal(false);
    handleChildClose();
  };

  // Add Item Row
  const addItem = () => {
    setItems([...items, { description: "", qty: "", discount: "", rate: "" }]);
  };

  // Delete Item Row
  const deleteItem = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        className={
          childModalOpen
            ? "invoice-parent-modal hide-parent-modal"
            : "invoice-parent-modal"
        }
        contentClassName={childModalOpen ? "hide-modal-content" : ""}
      >
        <Modal.Body>
          {/* HEADER */}
          <div className="d-flex justify-content-between mb-3">
            <Link  to="/invoices-page"  className="text-decoration-none text-dark" >
            <span className="fw-bold">← Back to List</span>
            </Link>
            <span
              style={{ color: "#ff6a00", cursor: "pointer" }}
              onClick={openPreview}
            >
              Preview
            </span>
          </div>

          {/* FROM SECTION */}
          <Card className="p-3 mb-3 bg-light">
            <div className="d-flex justify-content-between">
              <div>
                <h6>From</h6>
                <strong>Thomas Lawler</strong>
                <p className="mb-1 small">2077 Chicago Avenue</p>
                <p className="mb-1 small">Email</p>
                <p className="small">Phone</p>
              </div>

              <span style={{ cursor: "pointer" }}>✏ Edit Details</span>
            </div>
          </Card>

          {/* INVOICE DETAILS */}
          <h6>Invoice Details</h6>
          <Form className="mb-3">
            <Form.Group className="mb-2">
              <Form.Label>Invoice Title</Form.Label>
              <Form.Control />
            </Form.Group>

            <Row>
              <Col md={4}>
                <Form.Label>Invoice No</Form.Label>
                <Form.Control />
              </Col>
              <Col md={4}>
                <Form.Label>Invoice Date</Form.Label>
                <Form.Control type="date" />
              </Col>
              <Col md={4}>
                <Form.Label>Due Date</Form.Label>
                <Form.Control type="date" />
              </Col>
            </Row>
          </Form>

          {/* PAYMENT DETAILS */}
          <h6>Payment Details</h6>
          <Row className="mb-3">
            <Col md={3}>
              <Form.Label>
                Customer{" "}
                <span
                  style={{ color: "#ff6a00", cursor: "pointer" }}
                  onClick={openPaymentModal}
                >
                  + Add New
                </span>
              </Form.Label>
              <Form.Control />
            </Col>

            <Col md={3}>
              <Form.Label>Reference Number</Form.Label>
              <Form.Control />
            </Col>

            <Col md={3}>
              <Form.Label>Select Payment Type</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
                <option>Cash</option>
                <option>Online</option>
              </Form.Select>
            </Col>

            <Col md={3}>
              <Form.Label>Bank Details</Form.Label>
              <Form.Select className="custom-select">
                <option>Select</option>
                <option>HDFC</option>
                <option>SBI</option>
              </Form.Select>
            </Col>
          </Row>

          {/* ADD ITEMS */}
          <h6>Add Items</h6>
          {items.map((item, index) => (
            <Row key={index} className="align-items-center mb-2">
              <Col md={5}>
                <Form.Control placeholder="Description" />
              </Col>
              <Col md={2}>
                <Form.Control placeholder="Qty" />
              </Col>
              <Col md={2}>
                <Form.Control placeholder="Discount" />
              </Col>
              <Col md={2}>
                <Form.Control placeholder="Rate" />
              </Col>
              <Col md={1}>
                {index > 0 && (
                  <FiTrash2
                    color="red"
                    style={{ cursor: "pointer" }}
                    onClick={() => deleteItem(index)}
                  />
                )}
              </Col>
            </Row>
          ))}

          <span
            style={{ color: "#ff6a00", cursor: "pointer" }}
            onClick={addItem}
          >
            + Add New
          </span>

          {/* ADDITIONAL DETAILS */}
          <h6 className="mt-3">Additional Details</h6>
          <Form.Control as="textarea" rows={3} className="mb-2" />

          <Form.Label>Notes</Form.Label>
          <Form.Control as="textarea" rows={3} />

          {/* FOOTER */}
          <div className="d-flex justify-content-end mt-3">
            <Button variant="dark" className="me-2">
              Save as Draft
            </Button>
            <Button style={{ background: "#ff6a00", border: "none" }}>
              Save & Send
            </Button>
          </div>
        </Modal.Body>
        <style>
          {`.custom-select:focus {
  border-color: #ff6a00 !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);
}

.custom-select option:checked {
  background-color: #ff6a00 !important;
  color: white;
}

textarea:focus,
input:focus {
  border-color: #ff6a00 !important;
  box-shadow: 0 0 0 0.2rem rgba(255, 106, 0, 0.25);
}

.hide-modal-content {
  visibility: hidden;
}

.hide-parent-modal .modal-content {
  visibility: hidden !important;
}

.modal-backdrop,
.modal-backdrop.show {
  background-color: rgba(255,255,255,0.85) !important;
}`}
        </style>
      </Modal>

      {/* PREVIEW MODAL */}
      <PreviewModal
        show={preview}
        onHide={closePreview}
        onReopen={handleChildClose}
      />

      {/* PAYMENT MODAL */}
      <PaymentModal
        show={paymentModal}
        onHide={closePaymentModal}
        onReopen={handleChildClose}
      />
    </>
  );
}
